<div class="section pre-footer-section" [class.dark]="dark" [class.black]="black">
  @defer (on viewport) {
  <div class="pre-footer-blur"></div>
  }@placeholder {
  <div></div>
  }
  <div class="pre-footer" [class.color-dark]="dark">
    <div class="pre-footer-title">{{ title }}</div>

    <!-- <div class="checks">
      <div class="check" *ngIf="trialLengthDays">
        <app-svg src="/assets/icons/check.svg"></app-svg>
        <span>Free {{ trialLengthDays }}-Day Trial</span>
      </div>
      <div class="check" *onlyForScreens="['tablet', 'desktop']">
        <app-svg src="/assets/icons/check.svg"></app-svg>
        <span>Free & Paid Plans</span>
      </div>
      <div class="check">
        <app-svg src="/assets/icons/check.svg"></app-svg>
        <span>Cancel Anytime</span>
      </div>
    </div> -->

    <div class="cta">
      <ng-content></ng-content>
    </div>
    <!-- <app-screen [dark]="dark" [cutOffAtBottom]="true"> -->
    <app-picture
      [url]="dark ? darkImage || defaultDarkImage : lightImage || defaultLightImage"
      [width]="dark ? 1844 : 1920"
      [height]="dark ? 802 : 884"
      [scale]="1"
    ></app-picture>
    <!-- </app-screen> -->
    <div class="image-shadow"></div>
  </div>
</div>
